import { render, staticRenderFns } from "./app-main.vue?vue&type=template&id=e64c493e&scoped=true"
import script from "./app-main.vue?vue&type=script&lang=ts"
export * from "./app-main.vue?vue&type=script&lang=ts"
import style0 from "./app-main.vue?vue&type=style&index=0&id=e64c493e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64c493e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e64c493e')) {
      api.createRecord('e64c493e', component.options)
    } else {
      api.reload('e64c493e', component.options)
    }
    module.hot.accept("./app-main.vue?vue&type=template&id=e64c493e&scoped=true", function () {
      api.rerender('e64c493e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/app-main.vue"
export default component.exports